import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import "react-table/react-table.css";
import 'react-responsive-modal/lib/react-responsive-modal.css';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import Pagination from '../../page/Pagination'
import FormattedCurrencyValue from '../../fields/number/FormattedCurrencyValue';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { Link } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';

const log = new Logger('OSS_FILING_VALUES', LOG_LEVELS.DEBUG);
const LANGUAGE_PREFIX = 'ossFilingValues_';
const TransactionSearchLink = '/TransactionSearch?exactMatch=1&reference=';
export class OSSFilingValues extends Component {
    constructor(props) {
        super(props);
    }
    getColumns(columnData) {
        return columnData.map((item) => {
            return {
                id: item.accessor,
                Header: props => <LanguageStringResolver string={LANGUAGE_PREFIX + item.header.replace(/ +/g, "")} />,
                accessor:
                    (item.dataType === 'Currency')?
                        d =>
                         <FormattedCurrencyValue value={d[item.accessor]} inputFieldClassName={withFullStoryExclude()} /> : item.accessor,
                Cell: (item.accessor === 'invoiceNumber') ?
                    ({ original={} }) => {
                        //redirect to TransactionSearch page
                        let linkToUrl = TransactionSearchLink + original.invoiceNumber + '&searchType=0';
                        let linkComponent = (<Link to={linkToUrl}>{original.invoiceNumber}</Link>);
                        return (
                            <div>
                                {linkComponent}
                            </div>
                        );
                    } :''
            }
        });
    }

    onSelectGroupType (event) {
        if(typeof this.props.onGroupTypeChangeHandler === 'function') {
            this.props.onGroupTypeChangeHandler(event);
        }
    }
    render() {
        log.debug('render(): ', this.props);

        //Get lines
        const ossLinesData = this.props.filingValues && this.props.filingValues.lines || [];
        const columnData = this.props.filingValues && this.props.filingValues.columnData || [];
        var columnsToAdd = this.getColumns(columnData);

        return (
            <div data-test="oss-filing-values-form">
                <div>
                    {!this.props.featureFlag?.EnableIOSSCorrection &&
                        <s-row>
                            <s-col span="6">
                                <fieldset className="mt10" role="radiogroup" aria-labelledby="label2" data-test="oss-values-option">
                                    <input
                                        type="radio"
                                        name="viewType"
                                        id='Grouped'
                                        value="1"
                                        checked={this.props.selectedGroupType === "1"}
                                        onClick={this.onSelectGroupType.bind(this)}
                                    />
                                    <label className="radio" htmlFor="Grouped"><LanguageStringResolver string='ossFilingValues_Grouped' />  </label>
                                    <input
                                        type="radio"
                                        name="viewType"
                                        value="0"
                                        id='Detailed'
                                        checked={this.props.selectedGroupType === "0"}
                                        onClick={this.onSelectGroupType.bind(this)}
                                    /><label className="radio" htmlFor="Detailed"><LanguageStringResolver string='ossFilingValues_Detailed' /> </label>
                                </fieldset>
                            </s-col>
                        </s-row>
                    }
                    <ReactTable
                        data={ossLinesData}
                        columns={columnsToAdd}
                        minRows={0}
                        maxRows={0}
                        className="-striped -highlight header-no-filters"
                        noDataText={<LanguageStringResolver string='ecListingFilingValues_NoData'/>}
                        resizable={true}
                        sortable={false}
                        defaultPageSize={20}
                        pageSizeOptions={[ 20, 50, 100, 1000]}
                        showPagination={ossLinesData.length !== 0}
                        PaginationComponent={Pagination}
                        data-test="oss-values-table"
                    />
                    <br></br>
                    <CSVLink
                        data-test="oss-values-csvlink"
                        data={sanitizeCsvData(ossLinesData)}
                        filename={this.props.fileName + '.csv'}
                        className={ossLinesData && ossLinesData.length > 0 ? "button secondary" : "invisible"}>
                        <LanguageStringResolver string='ossFilingValues_ExportToExcel' />
                    </CSVLink>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        featureFlag: state.featureFlag?.data
    };
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(OSSFilingValues);
